import { LOGS_URL } from "../constants";

export const parseUTCNameToDate = (str) => {
  // Преобразует "25.07.22.17" => объект Date
  const [year, month, day, hour] = str.split(".").map(Number);
  return new Date(Date.UTC(2000 + year, month - 1, day, hour));
};

// Преобразует объект Date в строку "25.07.22.17"
export const dateToUTCName = (date) => {
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(date.getUTCFullYear() % 100)}.${pad(date.getUTCMonth() + 1)}.${pad(date.getUTCDate())}.${pad(date.getUTCHours())}`;
};

const floorHour = (t) => {
    let time = new Date(t);
    time.setMinutes(0);
    time.setSeconds(0);
    time.setMilliseconds(0);
    return time;
}

const defineFile = (t, varName) => {
    // const t= new Date(msec);//local date
    const name = `${varName}.${dateToUTCName(t)}`;
    const url = `${LOGS_URL}/${varName}/${name}`;
    
    return {name, url}
}

export const defineFileList = (ta, tb, varName) =>{
    // console.log('--------------define list-----------');
    let i = new Date(tb); 
    let start = new Date(ta);

    let list = [];
    let hour_begining=null;
    do {
        const {name, url} = defineFile(i, varName);
        // console.log('add');
        hour_begining = floorHour(i);
        // console.log(hour_begining);
        list.push({name, url, time:hour_begining});
        // console.log(list);
        
        // console.log('curr hour '+dateToUTCName(i));
        //!! отнимаем миллисекунду чтобы перейти в предыдущий час
        i = new Date(hour_begining.getTime() - 1);
        // console.log('prev hour '+dateToUTCName(i));
    } while (hour_begining>ta)
    return list;
}

const floorDay = (t) => {
    let time = new Date(t);
    time.setHours(0);
    time.setMinutes(0);
    time.setSeconds(0);
    time.setMilliseconds(0);
    return time;
}

// Преобразует объект Date в строку "25.07.22"
export const localDateToUtcDayPointString = (date) => {
  const pad = (n) => n.toString().padStart(2, "0");
  return `${pad(date.getUTCFullYear() % 100)}.${pad(date.getUTCMonth() + 1)}.${pad(date.getUTCDate())}`;
};

export const defineDayFile = (t, varName) => {
  console.log('define day file: '+varName);
  
    // const t= new Date(msec);//local date
    const name = `${varName}.${localDateToUtcDayPointString(t)}`;
    const url = `${LOGS_URL}/daily/${varName}/${name}`;
    
    return {name, url}
}



export const defineFileDays = (ta, tb, varName) =>{
    console.log('--------------define list-----------');
    console.log(`ta ${ta}`);
    console.log(`tb ${tb}`);
    
    let i = new Date(tb); 
    let start = new Date(ta);

    let list = [];
    let day_begining=null;
    do {
        const {name, url} = defineDayFile(i, varName);
        console.log('add');
        day_begining = floorDay(i);
        console.log(day_begining);
        list.push({name, url, time:day_begining});
        console.log(list);
        
        console.log('curr day '+localDateToUtcDayPointString(i));
        //!! отнимаем миллисекунду чтобы перейти в предыдущий час
        i = new Date(day_begining.getTime() - 1);
        // console.log('prev hour '+dateToUTCName(i));
    } while (day_begining>ta)
    return list;
}